/* ============================================================
   SUPPLY SPHERE SOLUTIONS — theme.js
   Fade-in · Mobile nav · Service tabs · Enquiry selector
   Newsletter · Contact form · Add to cart · Variants
   Qty controls · Gallery · Filters · Recommendations
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ── FADE IN ON SCROLL ── */
  var fadeEls = document.querySelectorAll('.fade-in');
  if (fadeEls.length && 'IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.08 });
    fadeEls.forEach(function (el) { obs.observe(el); });
  } else {
    fadeEls.forEach(function (el) { el.classList.add('visible'); });
  }

  /* ── MOBILE NAV ── */
  var navToggle = document.querySelector('.nav-toggle');
  var mobileMenu = document.querySelector('.mobile-menu');
  if (navToggle && mobileMenu) {
    navToggle.addEventListener('click', function () {
      var open = mobileMenu.classList.toggle('open');
      navToggle.setAttribute('aria-expanded', open);
    });
  }

  /* ── SERVICE TABS SCROLL HIGHLIGHT ── */
  var serviceSections = document.querySelectorAll('[data-service-id]');
  var serviceTabs = document.querySelectorAll('.service-tab');
  if (serviceSections.length && serviceTabs.length) {
    window.addEventListener('scroll', function () {
      var current = '';
      serviceSections.forEach(function (sec) {
        if (window.scrollY >= sec.offsetTop - 140) current = sec.getAttribute('data-service-id');
      });
      serviceTabs.forEach(function (tab) {
        tab.classList.toggle('active', tab.getAttribute('href') === '#' + current);
      });
    }, { passive: true });
  }

  /* ── ENQUIRY TYPE SELECTOR ── */
  document.querySelectorAll('.enq-option').forEach(function (opt) {
    opt.addEventListener('click', function () {
      document.querySelectorAll('.enq-option').forEach(function (o) { o.classList.remove('selected'); });
      opt.classList.add('selected');
    });
  });

  /* ── NEWSLETTER FORM ── */
  document.querySelectorAll('.js-newsletter-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.textContent = 'Subscribed ✓'; btn.disabled = true; }
    });
  });

  /* ── CONTACT FORM ── */
  var contactForm = document.querySelector('.js-contact-form');
  if (contactForm) {
    contactForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = contactForm.querySelector('.btn-submit');
      if (btn) { btn.innerHTML = 'Message Sent ✓'; btn.disabled = true; btn.style.background = '#2d6a4f'; }
    });
  }

  /* ── FILTER TOGGLES ── */
  document.querySelectorAll('.js-filter-toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') !== 'false';
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    });
  });

  /* ── FILTER AUTO-SUBMIT ON CHECKBOX ── */
  document.addEventListener('change', function (e) {
    if (e.target.closest('.js-filter-input')) submitFilters();
  });

  /* ── SORT SELECT ── */
  var sortSel = document.querySelector('.js-sort-select');
  if (sortSel) {
    sortSel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSel.value);
      window.location.href = url.toString();
    });
  }

  /* ── PRICE FILTER APPLY ── */
  document.addEventListener('click', function (e) {
    if (e.target.closest('.js-apply-price-filter')) submitFilters();
  });

  function submitFilters() {
    var url = new URL(window.location.href);
    Array.from(url.searchParams.keys()).forEach(function (k) { if (k.startsWith('filter.')) url.searchParams.delete(k); });
    document.querySelectorAll('.js-filter-input:checked').forEach(function (inp) { url.searchParams.append(inp.name, inp.value); });
    var minInp = document.querySelector('.js-price-min');
    var maxInp = document.querySelector('.js-price-max');
    if (minInp && minInp.value) url.searchParams.set(minInp.name, Math.round(parseFloat(minInp.value) * 100));
    if (maxInp && maxInp.value) url.searchParams.set(maxInp.name, Math.round(parseFloat(maxInp.value) * 100));
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }

  /* ── PRODUCT GALLERY THUMBNAILS ── */
  var gallery = document.querySelector('.js-product-gallery');
  if (gallery) {
    gallery.addEventListener('click', function (e) {
      var thumb = e.target.closest('.js-gallery-thumb');
      if (!thumb) return;
      var idx = parseInt(thumb.dataset.index, 10);
      gallery.querySelectorAll('.product-gallery__slide').forEach(function (s, i) { s.classList.toggle('active', i === idx); });
      gallery.querySelectorAll('.product-gallery__thumb').forEach(function (t, i) { t.classList.toggle('active', i === idx); });
    });
  }

  /* ── PRODUCT VARIANTS ── */
  var productForm = document.querySelector('.js-product-form');
  if (productForm && window.productVariants) {
    var variants = window.productVariants;
    var selectedOptions = [];

    productForm.querySelectorAll('.js-option-btn.selected').forEach(function (btn) {
      selectedOptions[parseInt(btn.dataset.optionIndex, 10)] = btn.dataset.value;
    });

    productForm.addEventListener('click', function (e) {
      var btn = e.target.closest('.js-option-btn');
      if (!btn) return;
      var idx = parseInt(btn.dataset.optionIndex, 10);
      selectedOptions[idx] = btn.dataset.value;
      productForm.querySelectorAll('.js-option-btn[data-option-index="' + idx + '"]').forEach(function (b) {
        b.classList.toggle('selected', b.dataset.value === btn.dataset.value);
      });
      updateVariant();
    });

    function updateVariant() {
      var variant = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selectedOptions[i]; });
      });
      if (!variant) return;
      var idInput = productForm.querySelector('.js-variant-id');
      if (idInput) idInput.value = variant.id;
      var priceEl = document.querySelector('.js-product-price');
      if (priceEl) {
        if (variant.compare_at_price > variant.price) {
          priceEl.innerHTML = '<span class="product-info__price--sale">' + fmtMoney(variant.price) + '</span><span class="product-info__price--was">' + fmtMoney(variant.compare_at_price) + '</span>';
        } else {
          priceEl.innerHTML = '<span class="product-info__price--current">' + fmtMoney(variant.price) + '</span>';
        }
      }
      var skuEl = document.querySelector('.js-sku');
      if (skuEl) skuEl.style.display = variant.sku ? '' : 'none';
      var addBtn = productForm.querySelector('.js-add-to-cart');
      var addLabel = productForm.querySelector('.js-add-label');
      if (addBtn) addBtn.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    function fmtMoney(cents) {
      return 'R' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }

  /* ── PRODUCT QTY CONTROLS ── */
  document.addEventListener('click', function (e) {
    var dec = e.target.closest('.js-qty-decrement');
    var inc = e.target.closest('.js-qty-increment');
    if (!dec && !inc) return;
    var wrap = (dec || inc).closest('.product-form__qty-wrap');
    var input = wrap && wrap.querySelector('.product-form__qty-input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    input.value = dec ? Math.max(1, val - 1) : val + 1;
  });

  /* ── CART PAGE QTY CONTROLS ── */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('.js-cart-qty-minus');
    var plus  = e.target.closest('.js-cart-qty-plus');
    if (!minus && !plus) return;
    var item  = (minus || plus).closest('.cart-item');
    var input = item && item.querySelector('.js-cart-qty-input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    input.value = minus ? Math.max(0, val - 1) : val + 1;
  });

  /* ── ADD TO CART (card forms) ── */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.js-card-form, .js-product-form');
    if (!form) return;
    e.preventDefault();
    var labelEl = form.querySelector('.js-add-label');
    var btn     = form.querySelector('.js-add-to-cart');
    var origLabel = labelEl ? labelEl.textContent : 'Add to Cart';
    if (labelEl) labelEl.textContent = 'Adding…';
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (labelEl) labelEl.textContent = 'Added ✓';
        updateCartCount();
        setTimeout(function () {
          if (labelEl) labelEl.textContent = origLabel;
          if (btn) btn.disabled = false;
        }, 2000);
      })
      .catch(function () {
        if (labelEl) labelEl.textContent = 'Error — try again';
        if (btn) btn.disabled = false;
      });
  });

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.js-cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.dataset.count = cart.item_count;
        });
      });
  }

  /* ── PRODUCT RECOMMENDATIONS ── */
  var recsWrapper = document.getElementById('product-recommendations');
  if (recsWrapper) {
    var productId = recsWrapper.dataset.productId;
    var limit     = recsWrapper.dataset.limit || 4;
    fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + limit)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.products || !data.products.length) return;
        var grid = recsWrapper.querySelector('.js-recommendations-grid');
        var inner = recsWrapper.querySelector('.recommendations-inner');
        if (!grid) return;
        grid.style.display = '';
        grid.innerHTML = data.products.map(function (p) {
          var img = p.featured_image ? '<img src="' + p.featured_image.replace(/(\.\w+)$/, '_600x600$1') + '" alt="' + p.title + '" loading="lazy" style="width:100%; aspect-ratio:1; object-fit:cover;">' : '';
          return '<div class="product-card"><a href="' + p.url + '" class="product-card__img-wrap">' + img + '</a><div class="product-card__info"><a href="' + p.url + '" class="product-card__title">' + p.title + '</a><div class="product-card__price">R' + (p.price / 100).toFixed(2) + '</div><a href="' + p.url + '" class="btn btn-outline product-card__btn">View Product</a></div></div>';
        }).join('');
        if (inner) inner.style.display = '';
        else recsWrapper.style.display = '';
      })
      .catch(function () {});
  }

});

/* ── WISHLIST (Save / Unsave) ── */
(function() {
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem('sss_wishlist') || '[]'); } catch(e) { return []; }
  }
  function saveWishlist(list) {
    try { localStorage.setItem('sss_wishlist', JSON.stringify(list)); } catch(e) {}
  }
  function isInWishlist(handle) {
    return getWishlist().some(function(i) { return i.handle === handle; });
  }
  function updateWishlistBtns() {
    document.querySelectorAll('.js-wishlist-btn').forEach(function(btn) {
      var handle = btn.dataset.handle;
      var saved  = isInWishlist(handle);
      btn.classList.toggle('saved', saved);
      btn.setAttribute('aria-label', saved ? 'Remove from saved' : 'Save item');
      btn.title = saved ? 'Saved ✓' : 'Save';
    });
  }
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.js-wishlist-btn');
    if (!btn) return;
    var handle = btn.dataset.handle;
    var list   = getWishlist();
    var idx    = list.findIndex(function(i) { return i.handle === handle; });
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      list.push({
        handle: handle,
        title:  btn.dataset.title  || '',
        price:  btn.dataset.price  || 0,
        image:  btn.dataset.image  || '',
        url:    btn.dataset.url    || ''
      });
    }
    saveWishlist(list);
    updateWishlistBtns();
  });
  document.addEventListener('DOMContentLoaded', updateWishlistBtns);
})();

/* ── UPDATE CART COUNT VIA FETCH ── */
function updateCartCount() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      document.querySelectorAll('.js-cart-count').forEach(function(el) {
        el.textContent = cart.item_count;
        el.dataset.count = cart.item_count;
      });
    }).catch(function(){});
}
